import React from 'react'
import FilePreview from './FilePreview'

const FileList = ({
  files,
  onUpdateDescription,
  onUpdateCustomName,
  onRemoveFile,
  onEditPhoto,
  formatFileSize
}) => {
  if (files.length === 0) return null

  return (
    <div className="space-y-3">
      <h3 className="text-white font-medium">Selected Files ({files.length})</h3>
      {files.map((fileObj) => (
        <FilePreview
          key={fileObj.id}
          fileObj={fileObj}
          onUpdateDescription={onUpdateDescription}
          onUpdateCustomName={onUpdateCustomName}
          onRemoveFile={onRemoveFile}
          onEditPhoto={onEditPhoto}
          formatFileSize={formatFileSize}
        />
      ))}
    </div>
  )
}

export default FileList